export const plotlyRegisterConfig = {
    moduleType: "locale",
    name: "hu",
    dictionary: {
      Zoom: "Nagyítás egérrel",
      Pan: "Mozgatás egérrel",
      Autoscale: "Automatikus skálázás",
      "Download plot as a png": "Letöltés képként",
      "Zoom in": "Nagyítás",
      "Zoom out": "Kicsinyítés",
      "Reset axes": "Tengelyek visszaállítása",
      "Compare data on hover": "Adatok összehasonlítása",
      "Show closest data on hover": "Legközelebbi adat megjelenítése",
      "Taking snapshot - this may take a few seconds":
        "Kép készítése folyamatban...",
      "Snapshot succeeded": "A kép elkészült",
      "Double-click to zoom back out":
        "Dupla kattintással visszaállítható a nagyítás.",
      "Double-click on legend to isolate one trace":
        "A jelmagyarázaton történő dupla kattintással a vonal kiemelhető.",
      "Box Select": "Téglalap kijelölés",
      "Lasso Select": "Lasszó kijelölés",
      "Toggle Spike Lines": "Vezérvonalak megjelenítése"
    },
    format: {
      days: [
        "Vasárnap",
        "Hétfő",
        "Kedd",
        "Szerda",
        "Csütörtök",
        "Péntek",
        "Szombat"
      ],
      shortDays: ["Vas", "Hét", "Ked", "Sze", "Csü", "Pén", "Szo"],
      months: [
        "Január",
        "Február",
        "Március",
        "Április",
        "Május",
        "Június",
        "Július",
        "Augusztus",
        "Szeptember",
        "Október",
        "November",
        "December"
      ],
      shortMonths: [
        "Jan",
        "Feb",
        "Már",
        "Ápr",
        "Máj",
        "Jún",
        "Júl",
        "Aug",
        "Szep",
        "Okt",
        "Nov",
        "Dec"
      ],
      date: "%Y-%m-%d"
    }
  }